<div class="container-fluid content-container">
    <div class="content-container" *ngIf="helperService.user.isIncadea !== '1'; else incadea">
        <!-- Perfil Super Admin Retail Group -->
        <div class="row metrics-row" *ngIf="helperService.user.role.roleId === 4">
          <div class="contentcards" *ngFor="let item of dataKPI | async">
            <div class="loading-container">
                <section *ngIf="isLoading" style="margin: auto">
                    <div  class="pulsing">
                      <mat-spinner [diameter]="50" ></mat-spinner>
                    </div>
                    <p class="pulsing">{{"Loading" | translate }}</p>
                  </section>    
            </div>
            <div class="col-lg-4">
                <mat-card>
                    <mat-card-header>
                        <div mat-card-avatar class="metric-icons">
                            <i class="bi bi-person-check"></i>
                        </div>
                        <mat-card-title class="Asistencia"> {{ "Assistance" | translate}} </mat-card-title>
                        <mat-card-subtitle> {{ item.promedioAsistidasSuperRetailGroup }}% </mat-card-subtitle>
                    </mat-card-header>
                </mat-card>
            </div>
            <div class="col-lg-4">
                <mat-card>
                    <mat-card-header>
                        <div mat-card-avatar class="metric-icons2">
                            <i class="bi bi-person-x"></i>
                        </div>
                        <mat-card-title class="Citascanceladas"> {{ "NoShow" | translate}} </mat-card-title>
                        <mat-card-subtitle> {{ item.promedioNoShowSuperRetailGroup }}% </mat-card-subtitle>
                    </mat-card-header>
                </mat-card>
            </div>
            <div class="col-lg-4">
                <mat-card>
                    <mat-card-header>
                        <div mat-card-avatar class="metric-icons3">
                            <i class="bi bi-calendar2-x"></i>
                        </div>
                        <mat-card-title class="Inasistencia"> {{ "CanceledAppointments" | translate }} </mat-card-title>
                        <mat-card-subtitle> {{ item.promedioCancelSuperRetailGroup }}% </mat-card-subtitle>
                    </mat-card-header>
                </mat-card>
            </div>
          </div>
        </div>
        <!--Perfil Service Advisor Profile-->
        <div class="row metrics-row" *ngIf="helperService.user.role.roleId === 1">
         <div class="contentcards" *ngFor="let item of dataKPI | async">
            <div class="col-lg-4">
                <mat-card>
                    <mat-card-header>
                        <div mat-card-avatar class="metric-icons">
                            <i class="bi bi-calendar3-week"></i>
                        </div>
                        <mat-card-title class="Asistencia"> {{ "ScheduledAppointments" | translate}} </mat-card-title>
                        <mat-card-subtitle> {{ item.citasAdvisor }} </mat-card-subtitle>
                    </mat-card-header>
                </mat-card>
            </div>
            <div class="col-lg-4">
                <mat-card>
                    <mat-card-header>
                        <div mat-card-avatar class="metric-icons2">
                            <i class="bi bi-person-check"></i>
                        </div>
                        <mat-card-title class="Citascanceladas"> {{ "Assistance" | translate}} </mat-card-title>
                        <mat-card-subtitle> {{ item.promedioAsistenciaAdvisor }}% </mat-card-subtitle>
                    </mat-card-header>
                </mat-card>
            </div>
            <div class="col-lg-4">
                <mat-card>
                    <mat-card-header>
                        <div mat-card-avatar class="metric-icons3">
                            <i class="bi bi-person-x"></i>
                        </div>
                        <mat-card-title class="Inasistencia"> {{ "NoShow" | translate}} </mat-card-title>
                        <mat-card-subtitle> {{ item.promedioNoShowAdvisor }}% </mat-card-subtitle>
                    </mat-card-header>
                </mat-card>
             </div>
          </div>
        </div>
        <!--Perfil Workshop Super Admin-->
        <div class="row metrics-row" *ngIf="helperService.user.role.roleId === 2">
            <div class="contentcards" *ngFor="let item of dataKPI | async">
                <div class="col-lg-3">
                    <mat-card>
                        <mat-card-header>
                            <div mat-card-avatar class="metric-icons">
                                <i class="bi bi-person-check"></i>
                            </div>
                            <mat-card-title class="Asistencia"> {{ "Assistance" | translate}} </mat-card-title>
                            <mat-card-subtitle> {{ item.promedioAsistenciaWorkshop }}% </mat-card-subtitle>
                        </mat-card-header>
                    </mat-card>
                </div>
                <div class="col-lg-3">
                    <mat-card>
                        <mat-card-header>
                            <div mat-card-avatar class="metric-icons2">
                                <i class="bi bi-person-x"></i>
                            </div>
                            <mat-card-title class="Citascanceladas"> {{ "NoShow" | translate}} </mat-card-title>
                            <mat-card-subtitle> {{ item.promedioNoShowWorkshop }}% </mat-card-subtitle>
                        </mat-card-header>
                    </mat-card>
                </div>
                <div class="col-lg-3">
                    <mat-card>
                        <mat-card-header>
                            <div mat-card-avatar class="metric-icons3">
                                <i class="bi bi-calendar2-x"></i>
                            </div>
                            <mat-card-title class="Inasistencia"> {{ "CanceledAppointments" | translate }} </mat-card-title>
                            <mat-card-subtitle> {{ item.promedioCancelWorkshop }}% </mat-card-subtitle>
                        </mat-card-header>
                    </mat-card>
                </div>
                <div class="col-lg-3">
                    <mat-card>
                        <mat-card-header>
                            <div mat-card-avatar class="metric-icons4">
                                <i class="bi bi-calendar"></i>
                            </div>
                            <mat-card-title class="AtencionesSincita"> {{ "ServicesWithoutAppointment" | translate }} </mat-card-title>
                            <mat-card-subtitle> {{item.atencionesSinCitaWorkshop}} </mat-card-subtitle>
                        </mat-card-header>
                    </mat-card>
                </div>
            </div>
        </div>
        <!--Perfil Workshop Assistant-->
        <div class="row metrics-row" *ngIf="helperService.user.role.roleId === 6">
            <div class="contentcards" *ngFor="let item of dataKPI | async">
                <div class="col-lg-3">
                    <mat-card>
                        <mat-card-header>
                            <div mat-card-avatar class="metric-icons">
                                <i class="bi bi-person-check"></i>
                            </div>
                            <mat-card-title class="Asistencia"> {{ "Assistance" | translate}} </mat-card-title>
                            <mat-card-subtitle> {{ item.promedioAsistenciaWorkshopAssistant }}% </mat-card-subtitle>
                        </mat-card-header>
                    </mat-card>
                </div>
                <div class="col-lg-3">
                    <mat-card>
                        <mat-card-header>
                            <div mat-card-avatar class="metric-icons2">
                                <i class="bi bi-person-x"></i>
                            </div>
                            <mat-card-title class="Citascanceladas"> {{ "NoShow" | translate}} </mat-card-title>
                            <mat-card-subtitle> {{ item.promedioNoShowWorkshopAssistant }}% </mat-card-subtitle>
                        </mat-card-header>
                    </mat-card>
                </div>
                <div class="col-lg-3">
                    <mat-card>
                        <mat-card-header>
                            <div mat-card-avatar class="metric-icons3">
                                <i class="bi bi-calendar2-x"></i>
                            </div>
                            <mat-card-title class="Inasistencia"> {{ "CanceledAppointments" | translate }} </mat-card-title>
                            <mat-card-subtitle> {{ item.promedioCancelWorkshopAssistant }}% </mat-card-subtitle>
                        </mat-card-header>
                    </mat-card>
                </div>
                <div class="col-lg-3">
                    <mat-card>
                        <mat-card-header>
                            <div mat-card-avatar class="metric-icons4">
                                <i class="bi bi-calendar"></i>
                            </div>
                            <mat-card-title class="AtencionesSincita"> {{ "ServicesWithoutAppointment" | translate }} </mat-card-title>
                            <mat-card-subtitle> {{item.atencionesSinCitaWorkshopAssistant}} </mat-card-subtitle>
                        </mat-card-header>
                    </mat-card>
                </div>
            </div>
        </div>
        <!--Perfil Contact Center Advisor-->
        <div class="row metrics-row" *ngIf="helperService.user.role.roleId === 3">
            <div class="contentcards" *ngFor="let item of dataKPI | async">
                <div class="col-lg-4">
                    <mat-card>
                        <mat-card-header>
                            <div mat-card-avatar class="metric-icons">
                                <i class="bi bi-person-x"></i>
                            </div>
                            <mat-card-title class="Asistencia"> {{ "NoShow" | translate}} </mat-card-title>
                            <mat-card-subtitle> {{ item.noShowContactCenter }} </mat-card-subtitle>
                        </mat-card-header>
                    </mat-card>
                </div>
                <div class="col-lg-4">
                    <mat-card>
                        <mat-card-header class="card-fail">
                            <div mat-card-avatar class="metric-icons2">
                                <i class="bi bi-calendar2-x"></i>
                            </div>
                            <mat-card-title class="Citascanceladas"> {{ "CanceledAppointments" | translate }} </mat-card-title>
                            <mat-card-subtitle> {{ item.cancelContactCenter }} </mat-card-subtitle>
                        </mat-card-header>
                    </mat-card>
                </div>
                <div class="col-lg-4">
                    <mat-card>
                        <mat-card-header>
                            <div mat-card-avatar class="metric-icons3">
                                <i class="bi bi-calendar3-week"></i>
                            </div>
                            <mat-card-title class="ContactCenter"> {{ "ContactCenterParticipation" | translate }} </mat-card-title>
                            <mat-card-subtitle> {{ item.participacionContactCenter }}% </mat-card-subtitle>
                        </mat-card-header>
                    </mat-card>
                </div>
            </div>
        </div>
        <!-- Perfil Branding Consultant -->
        <div class="row metrics-row" *ngIf="helperService.user.role.roleId === 5">
            <div class="contentcards" *ngFor="let item of dataKPI | async">
                <div class="col-lg-4">
                    <mat-card>
                        <mat-card-header>
                            <div mat-card-avatar class="metric-icons">
                                <i class="bi bi-person-check"></i>
                            </div>
                            <mat-card-title class="Asistencia"> {{ "Assistance" | translate}} </mat-card-title>
                            <mat-card-subtitle> {{ item.promedioAsistidasBrand }}% </mat-card-subtitle>
                        </mat-card-header>
                    </mat-card>
                </div>
                <div class="col-lg-4">
                    <mat-card>
                        <mat-card-header>
                            <div mat-card-avatar class="metric-icons2">
                                <i class="bi bi-person-x"></i>
                            </div>
                            <mat-card-title class="Citascanceladas"> {{ "NoShow" | translate}} </mat-card-title>
                            <mat-card-subtitle> {{ item.promedioNoShowBrand }}% </mat-card-subtitle>
                        </mat-card-header>
                    </mat-card>
                </div>
                <div class="col-lg-4">
                    <mat-card>
                        <mat-card-header>
                            <div mat-card-avatar class="metric-icons3">
                                <i class="bi bi-calendar2-x"></i>
                            </div>
                            <mat-card-title class="Inasistencia"> {{ "CanceledAppointments" | translate }} </mat-card-title>
                            <mat-card-subtitle> {{ item.promedioCancelBrand }}% </mat-card-subtitle>
                        </mat-card-header>
                    </mat-card>
                </div>
            </div>
        </div>
        <!-- Perfil Super Admin Retail Group - Branding Consultant ocultar Widget calendario -->
        <div class="row widget-calendar" *ngIf="helperService.user.role.roleId  !== 4 && helperService.user.role.roleId !== 5">
            <div class="widgets-container" [ngClass]="calendarGrid">
                <mat-card
                    [ngClass]="{'widgets calendar-widget':isChartExpanded,'widgets calendar-widget2':!isChartExpanded}">
                    <app-calendar [years]="years" [isCalendarCollapsed]="isChartExpanded"></app-calendar>

                    <div class="txtmonth"
                        *ngIf="isChartExpanded"> {{years[selectedMonth - 1] | translate | uppercase}}
                    </div>
                    <div class="txtmycalendar"
                        *ngIf="isChartExpanded"> {{ "MyCalendar" | translate}}
                    </div>

                </mat-card>
            </div>
            <div class="widgets-container" [ngClass]="chartGrid">
                <mat-card class="widgets">
                    <app-overall-summary
                        (onToggleExpandCollapseChart)="expandCollapseChart($event)"></app-overall-summary>
                </mat-card>
            </div>
        </div>
        <!-- Perfil Super Admin Retail Group - Branding Consultant grafico barras -->
        <div class="widgets-container retail" [ngClass]="chartGrid2" *ngIf="helperService.user.role.roleId === 4 || helperService.user.role.roleId === 5">
            <mat-card class="widgets">
                <app-overall-summary
                    (onToggleExpandCollapseChart)="expandCollapseChart($event)"></app-overall-summary>
            </mat-card>
        </div>
    </div>
    <ng-template #incadea>
        <app-i-dashboard></app-i-dashboard>
    </ng-template>
</div>
